<template>
  <div class="loadingLeftNav">
    <h2 class="cell small-10 h1">
      {{ title }}
    </h2>
    <AtomicUiSkeleton width="90%" height="1.87rem" class="subText" />
    <AtomicUiSkeleton width="90%" height="1.56rem" class="title" />
    <AtomicUiSkeleton width="70%" height="0.93rem" class="headingText m-left" />
    <AtomicUiSkeleton width="70%" height="0.93rem" class="subText m-left" />
    <AtomicUiSkeleton width="90%" height="1.56rem" class="title" />
    <AtomicUiSkeleton width="70%" height="0.93rem" class="headingText m-left" />
    <AtomicUiSkeleton width="70%" height="0.93rem" class="headingText m-left" />
    <AtomicUiSkeleton width="70%" height="0.93rem" class="subText m-left" />
    <AtomicUiSkeleton width="90%" height="1.56rem" class="title" />
    <AtomicUiSkeleton width="70%" height="0.93rem" class="headingText m-left" />
    <AtomicUiSkeleton width="70%" height="0.93rem" class="headingText m-left" />
    <AtomicUiSkeleton width="70%" height="0.93rem" class="subText m-left" />
    <AtomicUiSkeleton width="90%" height="1.56rem" class="subText" />
    <AtomicUiSkeleton width="90%" height="1.56rem" class="title" />
    <AtomicUiSkeleton width="70%" height="0.93rem" class="headingText m-left" />
    <AtomicUiSkeleton width="70%" height="0.93rem" class="headingText m-left" />
    <AtomicUiSkeleton width="70%" height="0.93rem" class="subText m-left" />
    <AtomicUiSkeleton width="90%" height="1.56rem" class="subText" />
    <AtomicUiSkeleton width="90%" height="1.56rem" class="subText" />
    <AtomicUiSkeleton width="90%" height="1.56rem" class="subText" />
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
.title {
  margin-bottom: rem-calc(10);
}
.headingText {
  margin-bottom: rem-calc(15);
}
.subText {
  margin-bottom: rem-calc(40);
}
.m-left {
  margin-left: rem-calc(20);
}
.loadingLeftNav {
  width: 15.62rem;
}
</style>
